import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import styles from 'modules/Finance/Wallets/subcomponents/WalletsList/WalletListSkeleton.module.scss'
import { Grid } from 'gu-ui-kit'

const WalletListSkeleton = ({ className = '' }) => (
  <div className={clsx('wallets-list-skeleton', styles['wallets-list-skeleton'], className)}>
    <ul className={styles['wallets-list-skeleton__list']}>
      {Array.apply(null, Array(5)).map((val, i) => (
        <Grid
          component={'li'}
          gap={8}
          className={styles['wallets-list-skeleton__list-item']}
          key={'wallet-skeleton-row' + i}
        >
          <div className={clsx(styles['wallets-list-skeleton__fig'])} />
          <div className={styles['wallets-list-skeleton__summary']}>
            <div
              className={clsx(
                styles['wallets-list-skeleton__summary-text'],
                styles['wallets-list-skeleton__summary-text_type2'],
              )}
            />
            <div className={styles['wallets-list-skeleton__summary-text']} />
          </div>
        </Grid>
      ))}
    </ul>
  </div>
)

export default WalletListSkeleton

WalletListSkeleton.propTypes = {
  className: PropTypes.string,
}
